<template>
    <div class="home">
        <div style="margin-bottom: 20px">
            <label for="im_message">インフォ</label><input id="im_message" v-model="important"/><br/>
            <button @click="update_info()">メッセージ送信</button>
        </div>
        <label for="message">インフォ</label><input id="message" v-model="information"/><br/>
        <button @click="send_info()">メッセージ送信</button>
        <div v-for="(value,key) in infos" v-bind:key="key">
            <div>{{value}}</div>
        </div>
        <div style="background-color: crimson;padding: 20px">
            <button @click="reset_bingo()">bingoリセット</button>
        </div>
    </div>
</template>

<script>
    /* eslint-disable no-console */

    // @ is an alias to /src
    import firebase from 'firebase'

    export default {
        name: 'home',
        data() {
            return {
                information: null,
                important: null
            }
        },
        methods: {
            send_info: function () {
                if (this.information !== null && confirm("メッセージを送信します")) {
                    firebase.database().ref('/info/infos').push(this.information)
                    this.information = null
                }
            },
            update_info: function () {
                if (this.important !== null && confirm("重要なメッセージを更新します")) 
                firebase.database().ref('/info/important').set(this.important)
                this.important = this.$store.getters.importantText
            },
            reset_bingo:function () {
                if (confirm("ビンゴを初期化していいですか?")){
                    firebase.database().ref('/bingo').set(null)
                }
            }
        },
        created:function(){
            console.log('実行')
            this.important = this.$store.getters.importantText
        },
        computed: {
            infos: function () {
                return this.$store.getters.infos
            }
        }
    }
</script>
